import React, { useState,useContext } from 'react';
import { Link, useLocation, NavLink } from 'react-router-dom';
import { AuthUserContext } from '../../../session';
import CIcon from '@coreui/icons-react';
import {
  cilHome,
  cilWallet,
  cilCreditCard,
  cilBank,
  cilPaw,
  cilSettings,
  cilLightbulb,
  cilMenu,
} from '@coreui/icons';
import { Button } from './ui/button';
import mierosLogo from '../../../../assets/milogo.png';
import { useToolsContext } from './hooks/ToolsPanelProvider';
import '../../../../scss/main.scss';
const navigationMenuItems = [
  {
    label: 'Home',
    href: '/dashboard/creator/home',
    icon: cilHome,
    paths: [],
  },
  {
    label: 'Customers',
    href: '/dashboard/creator/customers',
    icon: cilPaw,
    paths: [],
  },
  {
    label: 'Payments',
    href: '/dashboard/creator/payments',
    icon: cilWallet,
    paths: [],
  },
  {
    label: 'Payouts',
    href: '/dashboard/creator/payouts',
    icon: cilCreditCard,
    paths: [],
  },
  {
    label: 'Finances',
    href: '/dashboard/creator/finances',
    icon: cilBank,
    paths: ['/dashboard/creator/finances/cards'],
    shouldDisplayFilter: (stripeAccount) =>
      stripeAccount.controller?.stripe_dashboard?.type === 'none' &&
      stripeAccount.controller?.losses?.payments === 'application' &&
      stripeAccount.controller?.requirement_collection === 'application',
  },
  {
    label: 'Account',
    href: '/dashboard/creator/settings',
    icon: cilSettings,
    paths: ['/dashboard/creator/settings/documents', '/dashboard/creator/settings/tax'],
  },
];

const Nav = () => {
  const { pathname } = useLocation();
  const { authUser } = useContext(AuthUserContext);
  const stripeAccount = authUser?.stripeAccount;
  const { open, handleOpenChange } = useToolsContext();
  const [showMobileNavItems, setShowMobileNavItems] = useState(false);

  const getIconColor = (item) => {
    return pathname === item.href || item.paths.includes(pathname)
      ? 'var(--accent)'
      : 'var(--primary)';
  };

  return (
    <nav style={{
      backgroundColor: '#fff',
      borderBottom: '1px solid #e5e7eb',
      padding: '1rem',
      position: 'sticky',
      top: 0,
      zIndex: 1001,
      width: '100%'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        maxWidth: '1280px',
        margin: '0 auto',
        padding: '0 1rem'
      }}>
        <div className="nav-brand">
          <NavLink to="/" style={{ 
            fontSize: '1.5rem', 
            fontWeight: 'bold',
            color: '#187da0',
            textDecoration: 'none'
          }}>
            MiEROS
          </NavLink>
        </div>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <NavLink 
            to="/dashboard/creator/home" 
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            style={({ isActive }) => ({
              color: isActive ? '#187da0' : '#4b5563',
              textDecoration: 'none',
              padding: '0.5rem 1rem',
              borderRadius: '0.375rem',
              backgroundColor: isActive ? '#f3f4f6' : 'transparent'
            })}
          >
            Home
          </NavLink>
          <NavLink 
            to="/dashboard/creator/customers" 
            style={({ isActive }) => ({
              color: isActive ? '#187da0' : '#4b5563',
              textDecoration: 'none',
              padding: '0.5rem 1rem',
              borderRadius: '0.375rem',
              backgroundColor: isActive ? '#f3f4f6' : 'transparent'
            })}
          >
            Customers
          </NavLink>
          <NavLink 
            to="/dashboard/creator/payments" 
            style={({ isActive }) => ({
              color: isActive ? '#187da0' : '#4b5563',
              textDecoration: 'none',
              padding: '0.5rem 1rem',
              borderRadius: '0.375rem',
              backgroundColor: isActive ? '#f3f4f6' : 'transparent'
            })}
          >
            Payments
          </NavLink>
          <NavLink 
            to="/dashboard/creator/payouts" 
            style={({ isActive }) => ({
              color: isActive ? '#187da0' : '#4b5563',
              textDecoration: 'none',
              padding: '0.5rem 1rem',
              borderRadius: '0.375rem',
              backgroundColor: isActive ? '#f3f4f6' : 'transparent'
            })}
          >
            Payouts
          </NavLink>
        </div>
      </div>
    </nav>
  );
};

export default Nav; 